import * as actions from '../constants/actions';
import { IArticle } from '../definitions/news';
import { IPagination } from '../definitions/common';

interface IInitialState {
  articles: IArticle[];
  error: Error | undefined;
  pagination: IPagination | undefined;
}

const initialState: IInitialState = {
  error: undefined,
  articles: [],
  pagination: undefined
};

function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case actions.FETCH_ARTICLES_FULFILLED:
      return {
        ...state,
        articles: payload.articles,
        error: undefined,
        pagination: payload.pagination
      };

    case actions.FETCH_ARTICLES_REJECTED:
      return {
        ...state,
        error: payload
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/articles.ts